const APP_NAME = 'vite-react-tailwind-starter';

// react-helmet removed in the React 19 migration — React 19 natively hoists
// <title>/<meta>/<link> rendered anywhere in the tree up into <head>, so a
// portal library is no longer needed for this.
const Meta = () => {
  return (
    <>
      <title>Aspen</title>
      <meta name="description" content="Aspen Dental Program" />

      <meta name="application-name" content={APP_NAME} />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content={APP_NAME} />
      <meta name="format-detection" content="telephone=no" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="theme-color" content="#FFFFFF" />

      <link rel="shortcut icon" href="/assets/favicon.svg" />
    </>
  );
};

export default Meta;
